import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface IPillOption {
  label: string;
  isActive?: boolean;
  value: string;
}

/**
 * Display the pills filter that can be toggled
 */
@Component({
  selector: 'selection-pills',
  templateUrl: './selection-pills.component.html',
  styleUrls: ['./selection-pills.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectionPillsComponent),
      multi: true,
    },
  ],
})
export class SelectionPillsComponent implements ControlValueAccessor {
  @Input() public options: IPillOption[];
  private onChange: (_: string[]) => void;
  private onTouched: (_: string[]) => void;

  public togglePill(index: number): void {
    this.options[index].isActive = !this.options[index].isActive;

    const activePills: string[] = this.options.filter((item: IPillOption): boolean => item.isActive)
      .map((item: IPillOption): string => item.value);

    this.writeValue(activePills);
  }

  public writeValue(activePills: string[]): void {
    if (activePills) {
      for (const pillState of this.options) {
        pillState.isActive = activePills.indexOf(pillState.value) === -1 ? false : true;
      }

      this.onChange(activePills);
    }
  }

  public registerOnChange(fn: (pillOption: string[]) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void { /** */ }
}
